/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2023, Zumper
 */
import { memoizeState } from '@zcode/memoizers'
import type { Location } from 'history'

import { FILTERS_START_RE } from './shared/utils/urls'

// TODO: move to the routes package, once it exists?

/**
 * returns array of vertical filter names found in URL
 */
export const getVerticalsArray = memoizeState((location: Location<unknown>) => {
  if (typeof location.pathname === 'string') {
    return location.pathname
      .split('/')
      .filter((part) => `/${part}`.match(FILTERS_START_RE))
      .map((vertical) => vertical.replace(/-/g, ' '))
  }
  return []
})
